module.exports = __webpack_public_path__ + "img/sake_i.7224bdec.png";